import React from "react";

const Header = () => {
  return (
    <header className="bg-green-500 text-center text-2xl text-white font-bold p-3 shadow-lg">
      Blockchain Demo
    </header>
  );
};

export default Header;
